import * as React from 'react';
import { Box, TextField, Tooltip, AlertProps } from '@mui/material';
import { DataGrid, GridActionsCellItem, GridColDef, GridDataSource, GridGetRowsError, GridGetRowsParams, GridGetRowsResponse, GridRowId, GridRowModes, GridRowModesModel, useGridApiRef, GridDataSourceCache, GridColumnVisibilityModel, GridDataSourceCacheDefault } from '@mui/x-data-grid';
import ErrorBoundary from '../Common/ErrorBoundary';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import CustomDataGrid from '../Common/CustomDataGrid';

export default function Location() {
    const apiRef = useGridApiRef();
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState<GridColumnVisibilityModel>({});
    const [navigate, setNavigate] = React.useState<boolean>(false);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [lowTTLCache, setLowTTLCache] = React.useState<GridDataSourceCache>(() => new GridDataSourceCacheDefault({ ttl: 1000 * 10 }));
    const [snackbar, setSnackbar] = React.useState<Pick<AlertProps, 'children' | 'severity'> | null>(null);
    const handleCloseSnackbar = () => setSnackbar(null);
    
    React.useEffect(() => {
        
    }, [snackbar]);

    const dataSource: GridDataSource = {
      getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {

          const urlParams = new URLSearchParams();
          // if (params.paginationModel.page > 0) {
          urlParams.set('paginationModel', JSON.stringify(params.paginationModel));
          // }
          if (params.sortModel.length > 0) {
              urlParams.set('sortModel', JSON.stringify(params.sortModel));
          }
          if (params.filterModel.items.length > 0) {
              urlParams.set('filterModel', JSON.stringify(params.filterModel));
          }

          const urlParamsString = urlParams.size > 0 ? `?${urlParams.toString()}&entity_id=${localStorage.getItem('entity_id')}` : `?entity_id=${localStorage.getItem('entity_id')}`;
          const response = await fetch(`/admin/get-locations/${urlParamsString}`, {
            method: 'GET',
          });
          const data = await response.json();
          setTotalCount(data.rowCount);
          return {
              rows: data.rows,
              rowCount: data.rowCount,
          };
      },
    }

    const columns = [
      { 
        field: 'id', 
        headerName: 'ID', 
        width: 80, 
        align: 'center', 
        headerAlign: 'center', 
        type: 'number', 
        renderCell: (params) => {
          return <span>{params.value.toString().replace(',', '')}</span>;
        },
      },
      { field: 'loctn_nm', 
        headerName: 'Name', 
        width: 300, 
        editable: true, 
        align: 'center', 
        headerAlign: 'center', 
          renderEditCell: (params) => (
            <React.Fragment>
                {/* <FormControl variant="standard"> */}
                    <TextField
                        variant="standard"
                        size="small"
                        fullWidth
                        value={params.value}
                        onChange={(e) => {
                            // Update the cell value in the DataGrid's internal state
                            params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value });
                            if (parseFloat(e.target.value) > 100) {
                                setSnackbar({ children: 'Share of revenue must be between 0 and 100', severity: 'error' });
                            } else if (isNaN(parseFloat(e.target.value))) {
                                setSnackbar({ children: 'Share of revenue must be a number', severity: 'error' });
                            }else if (parseFloat(e.target.value) < 0) {
                                setSnackbar({ children: 'Share of revenue must be greater than 0', severity: 'error' });
                            }
                            else{
                                setSnackbar(null);
                            }
                        }}
                    />
                {/* </FormControl> */}
            </React.Fragment>
        ),
      },
      { field: 'entity_loctn_id', headerName: 'System ID', width: 150, align: 'center', headerAlign: 'center' },
      { field: 'loctn_grp_1', headerName: 'Group 1', width: 150, align: 'center', headerAlign: 'center' },
      { field: 'loctn_grp_2', headerName: 'Group 2', width: 150, align: 'center', headerAlign: 'center' },
      { field: 'created_at', headerName: 'Created At', width: 100, align: 'center', headerAlign: 'center' },
      { field: 'updated_at', headerName: 'Updated At', width: 100, align: 'center', headerAlign: 'center' },
    ];
        
    return (
      <ErrorBoundary fallback={<div>Error loading locations</div>}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', borderRadius: '10px', boxShadow: '0 0 2px #fff', border: 1, borderColor: 'divider', overflow: 'hidden' }}>  
          <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, padding: 0 }}>
              <Box sx={{ width: '100%', height: '100%', margin: 0, padding: 0, backgroundColor: 'white', borderRadius: '10px' }}>
                <CustomDataGrid
                  title="Locations"
                  url={`/admin/locations`}
                  exportUrl={`/admin/locations/export`}
                  columns={columns}
                  sortModel={[]}
                  gridDataSource={dataSource}
                  apiRef={apiRef}
                  rowModesModel={rowModesModel}
                  lowTTLCache={lowTTLCache}
                  navigate={navigate}
                  actions={['edit']}
                />
              </Box>
          </Box>
        </Box>
      </ErrorBoundary>
    );
}
